import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StoresComponent } from './stores/stores.component';
import { StoreOrderListComponent } from './store-order-list/store-order-list.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { ArchiveListComponent } from './archive-list/archive-list.component';
import { ShippingLabelsComponent } from './shipping-labels/shipping-labels.component';
import { CustomerOrdersComponent } from './customer-orders/customer-orders.component';

//import { MasterLayoutComponent } from '../mnt-master/master-layout/master-layout.component';

const routes: Routes = [
{
    path: '', component: StoresComponent,      
    //children: [{ path: '', component: StoresComponent }]
  },
  {
    path: 'order', component: StoreOrderListComponent      
    
  },
  {
    path: 'customer/:storeId', component: CustomerListComponent      
    
  },
  {
    path: 'archive-list', component: ArchiveListComponent      
    
  },
  {
    path: 'shipping-labels/:storeId', component: ShippingLabelsComponent      
  },
  {
    path: 'customer-orders/:storeId', component: CustomerOrdersComponent      
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MntStoresRoutingModule { }



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/mnt-stores-routing.module.ts